import React from 'react'

import { addPolygonRange, removePolygonRange } from 'Pods/SearchPage/Store/actions/polygon'
import { setAnimated, setPbr, setRigged } from 'Pods/SearchPage/Store/actions/threeDOnly'
import { POLYGON_RANGE } from 'Pods/SearchPage/Store/constants'
import I18n from 'Pods/Shared/I18n'

import TechnicalAttributesChip from './TechnicalAttributesChip'

const t = (key, options) => I18n.t(key, { ns: 'rails', ...options })

const handleLowPolyChange = (isChecked) => {
  if (isChecked) {
    addPolygonRange(POLYGON_RANGE.LOW_POLY)
  } else {
    removePolygonRange(POLYGON_RANGE.LOW_POLY)
  }
}

const CHIPS = [
  { key: 'animated', select: state => state.animated, onChange: setAnimated },
  { key: 'rigged', select: state => state.rigged, onChange: setRigged },
  {
    key: 'low_poly',
    select: state => state.polygonRanges.includes(POLYGON_RANGE.LOW_POLY),
    onChange: handleLowPolyChange,
  },
  { key: 'pbr', select: state => state.pbr, onChange: setPbr },
]

function TechnicalAttributes() {
  return (
    <div
      className="technical-attributes"
      role="group"
      aria-label={t('search_page.filters.technical_attributes.group_label')}
    >
      {CHIPS.map(({ key, select, onChange }) => (
        <TechnicalAttributesChip
          key={key}
          chipKey={key}
          select={select}
          onChange={onChange}
        />
      ))}
    </div>
  )
}

export default TechnicalAttributes
